import React from 'react';
import { Form } from 'react-final-form';

import CommonModal from '../../../../components/common-modal/CommonModal';
import validate from '../../../../utils/validate';
import PromptFormInner from './PromptFormInner';
import { commonPromptYopValidation } from './validation';

function PromptModal({
  isOpen,
  onClose,
  onCancel,
  onSubmit,
  title,
  placeholder,
  additionalInitialFields = {},
  AdditionalFields,
  validation = commonPromptYopValidation,
}) {
  const promptInitialValues = {
    description: '',

    ...additionalInitialFields,
  };

  const handleSubmit = async (values) => {
    await onSubmit(values);
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={promptInitialValues}
        onSubmit={handleSubmit}
        subscription={{ submitting: true, pristine: true, submitError: true }}
        validate={(values) => validate(values, validation())}
        render={({ handleSubmit }) => (
          <PromptFormInner
            onCancel={onCancel}
            AdditionalFields={AdditionalFields}
            handleSubmit={handleSubmit}
            title={title}
            placeholder={placeholder}
          />
        )}
      />
    </CommonModal>
  );
}

export default PromptModal;

export const PROMPT_MODAL_TYPE = {
  MODIFY: 'MODIFY',
  CUSTOM: 'CUSTOM',
  REVISE: 'REVISE',
};
